import React from 'react'
import { Row, Col, Space } from 'antd';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Slider from 'react-slick';
import { SvgArrowRightIcon } from '../../components/svg';
import ArticleHome from './article';
import { Helmet } from 'react-helmet';

const settings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false
};

const renderClient = () => {
  let element = []
  for (let index = 1; index <= 20; index++) {
    element.push(<Col key={index} xs={12} sm={8} md={4}>
      <div className='client-carousel--item' style={{ padding: '15px' }}>
        <img src={`/images/klien/klien${index}.png`} alt='MPX | CLIENT' style={{maxHeight: '75px'}} />
      </div>
    </Col>)
  }
  return element
}

const HomePage = () => {
  const { isMobileView } = useSelector(({ settings }) => settings)
  const { phrases } = useSelector(({ polyglot }) => polyglot)

  if (phrases) {
    const {
      pages: { home }, components: { buttons }
    } = phrases
    return (
      <>
        <Helmet title={process.env.REACT_APP_WEBSITE_MAIN_TITLE} />
        <div className='mpx-home'>
          <div className='mpx-home--about'>
            <div className='top' style={{ backgroundImage: isMobileView ? 'url("/images/mpx-home-about.png")' : 'none' }}>
              <div span={14} className='top--left'>
                <div className='wrap'>
                  <h1>
                    {home.aboutTitle}
                  </h1>
                  <p>
                    {home.aboutText}
                  </p>
                  {/* DELETE 001 */}
                </div>
              </div>
              <div span={10} className='top--right'>
                <div className='wrap'>
                  <img src='/images/mpx-home-about.png' alt='MPX | All in One Logistics Solution' />
                </div>
              </div>
              {!isMobileView && <img className='bg-circle' src='/images/assets/bg-circle.png' alt='MPX' />}
            </div>
            <div className='bottom'>
              <div className='mpx-container'>
                <Row>
                  <Col xs={24} lg={6}>
                    <h2>{home.aboutUs}</h2>
                  </Col>
                  <Col xs={24} lg={18}>
                    <p dangerouslySetInnerHTML={{ __html: home.aboutDesc }} />
                    <Link to='#'>
                      {buttons.readMore} &nbsp;<SvgArrowRightIcon />
                    </Link>
                  </Col>
                </Row>
              </div>
            </div>
          </div>
          <div className='mpx-home--work'>
            <h1 className='mpx-title'>
              {home.whatWeDo}
            </h1>
            <p className='mpx-title-desc'>
              {home.whatWeDoText}
            </p>
            {
              !isMobileView &&
              <div className='mpx-container'>
                <div className='wrap'>
                  <div className='item item__lt'>
                    <div className='item--head'>
                      {home.work1Title}
                    </div>
                    <div className='item--body'>
                      {home.work1Desc}
                    </div>
                  </div>
                  <div className='item item__rt'>
                    <div className='item--head'>
                      {home.work3Title}
                    </div>
                    <div className='item--body'>
                      {home.work3Desc}
                    </div>
                  </div>
                </div>
                <div className='wrap wrap__center'>
                  <div className='mpx-center'>
                    {/* <img src='/images/logo/logo-mpxgo-main-lg.png' alt='MPX | LOGO' /> */}
                    <img src='/images/logo/LOGO MLI WEBSITE.png' alt='MPX | LOGO' />
                  </div>
                </div>
                <div className='wrap'>
                  <div className='item item__lb'>
                    <div className='item--head'>
                      {home.work2Title}
                    </div>
                    <div className='item--body'>
                      {home.work2Desc}
                    </div>
                  </div>
                  <div className='item item__rb'>
                    <div className='item--head'>
                      {home.work4Title}
                    </div>
                    <div className='item--body'>
                      {home.work4Desc}
                    </div>
                  </div>
                </div>
              </div>
            }
            {
              isMobileView &&
              <div>
                <div className='wrap wrap__center'>
                  <div className='mpx-center'>
                    {/* <img src='/images/logo/logo-mpxgo-main-lg.png' alt='MPX | LOGO' /> */}
                    <img src='/images/logo/LOGO MLI WEBSITE.png' alt='MPX | LOGO' style={{maxWidth: '100%'}} />

                  </div>
                </div>
                <Slider {...settings}>
                  <div>
                    <div className='item'>
                      <div className='item--head'>
                        {home.work1Title}
                      </div>
                      <div className='item--body'>
                        {home.work1Desc}
                      </div>
                    </div>
                  </div>
                  <div>
                    <div className='item'>
                      <div className='item--head'>
                        {home.work2Title}
                      </div>
                      <div className='item--body'>
                        {home.work2Desc}
                      </div>
                    </div>
                  </div>
                  <div>
                    <div className='item'>
                      <div className='item--head'>
                        {home.work3Title}
                      </div>
                      <div className='item--body'>
                        {home.work3Desc}
                      </div>
                    </div>
                  </div>
                  <div>
                    <div className='item'>
                      <div className='item--head'>
                        {home.work4Title}
                      </div>
                      <div className='item--body'>
                        {home.work4Desc}
                      </div>
                    </div>
                  </div>
                </Slider>
              </div>
            }
          </div>
          <div className='mpx-home--feature'>
            <h1 className='mpx-title'>
              {home.whyMPX}
            </h1>
            <p className='mpx-title-desc'>
              {home.whyMPXText}
            </p>
            <div className='mpx-container'>
              <Row gutter={[30, 30]}>
                <Col xs={24} sm={12} md={8}>
                  <div className='item'>
                    <Space direction='vertical' align='center' size={10} style={{ width: '100%' }} >
                      <img src='/images/assets/icons/icon-stopwatch.png' alt='MPX | ICON' />
                      <h2>
                        {home.whyMPX1Title}
                      </h2>
                      {/* <p>
                      {home.whyMPX1Desc}
                    </p> */}
                    </Space>
                  </div>
                </Col>
                <Col xs={24} sm={12} md={8}>
                  <div className='item'>
                    <Space direction='vertical' align='center' size={10} style={{ width: '100%' }} >
                      <img src='/images/assets/icons/icon-headphone.png' alt='MPX | ICON' />
                      <h2>
                        {home.whyMPX2Title}
                      </h2>
                      {/* <p>
                      {home.whyMPX2Desc}
                    </p> */}
                    </Space>
                  </div>
                </Col>
                <Col xs={24} sm={12} md={8}>
                  <div className='item'>
                    <Space direction='vertical' align='center' size={10} style={{ width: '100%' }} >
                      <img src='/images/assets/icons/icon-star.png' alt='MPX | ICON' />
                      <h2>
                        {home.whyMPX3Title}
                      </h2>
                      {/* <p>
                      {home.whyMPX3Desc}
                    </p> */}
                    </Space>
                  </div>
                </Col >
                <Col xs={24} sm={12} md={8}>
                  <div className='item'>
                    <Space direction='vertical' align='center' size={10} style={{ width: '100%' }} >
                      <img src='/images/assets/icons/icon-tracking.png' alt='MPX | ICON' />
                      <h2>
                        {home.whyMPX4Title}
                      </h2>
                      {/* <p>
                      {home.whyMPX4Desc}
                    </p> */}
                    </Space>
                  </div>
                </Col >
                <Col xs={24} sm={12} md={8}>
                  <div className='item'>
                    <Space direction='vertical' align='center' size={10} style={{ width: '100%' }} >
                      <img src='/images/assets/icons/icon-book.png' alt='MPX | ICON' />
                      <h2>
                        {home.whyMPX5Title}
                      </h2>
                      {/* <p>
                      {home.whyMPX5Desc}
                    </p> */}
                    </Space>
                  </div>
                </Col >
                <Col xs={24} sm={12} md={8}>
                  <div className='item'>
                    <Space direction='vertical' align='center' size={10} style={{ width: '100%' }} >
                      <img src='/images/assets/icons/icon-user-relation.png' alt='MPX | ICON' />
                      <h2>
                        {home.whyMPX6Title}
                      </h2>
                      {/* <p>
                      {home.whyMPX6Desc}
                    </p> */}
                    </Space>
                  </div>
                </Col >
              </Row >
            </div >
          </div >
          <div className='mpx-home--client mpx-container'>
            <h1 className='mpx-title'>
              {home.ourClients}
            </h1>
            <p className='mpx-title-desc'>
              {home.ourClientsText}
            </p>
            <div className='client-carousel'>
              <Row gutter={[30, 30]} justify="center">
                {renderClient()}
              </Row>
            </div>
          </div>
          <ArticleHome />
        </div >
      </>
    );
  } else {
    return false
  }
}

export default HomePage;